import axios from "@/lib/axios";

type UpdateCompanyInfoRequestParams = {
  companyId: string;
  taxId: string;
  address: {
    street: string;
  };
  tradeName: string;
  website: string;
  principalProduct: string;
  startingYear: number;
  totalEmployees?: number;
};

type UpdateCompanyInfoResponse = void;

export const updateCompanyInfo = (params: UpdateCompanyInfoRequestParams) =>
  axios.patch<UpdateCompanyInfoResponse>(
    `/v1/companies/${params.companyId}/info`,
    {
      taxId: params.taxId,
      address: {
        street: params.address.street,
      },
      tradeName: params.tradeName,
      website: params.website,
      principalProduct: params.principalProduct,
      startingYear: params.startingYear,
      totalEmployees: params.totalEmployees,
    },
  );
